import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import '@G/lib/vue/antDesign'
import '@G/lib/vue/vueConfig'
import '@G/directive'
import VueClipboard from 'vue-clipboard2'

import '@G/sass/index.scss'

import DepartmentGraphqlProvider from '@G/api/department-graphql-provider'

//全域組件註冊
import VueProgressBar from '@G/lib/vue/vue-progress-bar.js'
import Breadcrumb from '@GC/Breadcrumb.vue'
import CustomCollapse from '@GC/CustomCollapse.vue'

// API Provider
import AuthProvider from '@G/api/auth-provider'

import * as filters from '@G/filters'

Vue.use(VueMeta)
Vue.use(VueClipboard)

// 註冊全域 Filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

VueProgressBar()
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('CustomCollapse', CustomCollapse)

Vue.config.productionTip = false

moment.locale(store.getters.lang)
Vue.prototype.$departmentGraphqlProvider = DepartmentGraphqlProvider
Vue.prototype.$authProvider = AuthProvider
Vue.prototype.$graphqlProvider = DepartmentGraphqlProvider

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.APP_CONFIG = app.$config
